import React, { useEffect, useState } from "react";
import "./NewsResult.css";
import config from "../config/config";

export const NewsResultPage = () => {
    const [news, setNews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [selectedNews, setSelectedNews] = useState(null);

    const fetchNews = async (pageNumber = 0) => {
        try {
            setLoading(true);
            const response = await fetch(`${config.apiUrl2}/api/news/control?page=${pageNumber}&size=5`);
            if (!response.ok) throw new Error("Ошибка загрузки новостей");
            const data = await response.json();
            setNews(data.content);
            setTotalPages(data.totalPages);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchNews(page);
    }, [page]);

    const openModal = (item) => setSelectedNews(item);
    const closeModal = () => setSelectedNews(null);

    if (loading) return <div className="news-page">Загрузка...</div>;
    if (error) return <div className="news-page">Ошибка: {error}</div>;

    return (
        <div className="news-page">
            <h2 className="section-title">НОВОСТИ</h2>

            <div className="news-list2">
                {news.map((item) => (
                    <div key={item.id} className="news-carddd" onClick={() => openModal(item)}>
                        <img
                            className="news-image"
                            src={
                                item.imageUrl
                                    ? item.imageUrl
                                    : `${config.apiUrl2}/api/news/images/${item.filename}`
                            }
                            alt={item.newsTitle || "Новость"}
                        />
                        <div className="news-content">
                            <div className="news-date">
                                {item.newsDate
                                    ? new Date(item.newsDate).toLocaleDateString("ru-RU") +
                                    " " +
                                    new Date(item.newsDate).toLocaleTimeString("ru-RU", {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                    })
                                    : ""}
                            </div>
                            <p className="news-text">
                                {item.newsContent
                                    ? item.newsContent.length > 150
                                        ? item.newsContent.slice(0, 150).match(/.{1,35}/g).join("\n") + "..."
                                        : item.newsContent
                                    : ""}
                            </p>
                            <button
                                className="read-more-btn"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    openModal(item);
                                }}
                            >
                                Подробнее
                            </button>
                        </div>
                    </div>
                ))}
            </div>

            <div className="pagination">
                <button onClick={() => setPage((p) => p - 1)} disabled={page === 0}>
                    ⬅ Предыдущая
                </button>
                <span>Страница {page + 1} из {totalPages}</span>
                <button onClick={() => setPage((p) => p + 1)} disabled={page === totalPages - 1}>
                    Следующая ➡
                </button>
            </div>

            {selectedNews && (
                <div className="modal-overlay" onClick={closeModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <h3>{selectedNews.newsTitle}</h3>
                        <div className="modal-date">
                            {selectedNews.newsDate
                                ? new Date(selectedNews.newsDate).toLocaleDateString("ru-RU") +
                                " " +
                                new Date(selectedNews.newsDate).toLocaleTimeString("ru-RU", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                })
                                : ""}
                        </div>
                        <p>{selectedNews.newsContent}</p>
                        <button className="modal-close-btn" onClick={closeModal}>
                            Закрыть
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};
